const DataEducation = {
    tecnologo: {
        titulo: "TECNÓLOGO - SENA - 2026",
        programa: "Análisis y Desarrollo de Software",
        institucion: "Centro de Industria y Construcción",
        ubicacion: "Ibagué, Tolima"
    },

    english: {
        titulo: "FORMACIÓN EN IDIOMA INGLÉS - 2026",
        programa: "Programa de inglés certificado (C1)",
        institucion: "Colombo Americano",
        ubicacion: "Ibagué, Tolima"
    },

    tecnico: {
        titulo: "TÉCNICO - 2023 - SENA",
        programa: "Gestión empresarial",
        institucion: "SENA (en convenio con institución educativa)"
    },

    school: {
        titulo: "BACHILLER - 2023",
        programa: "Bachillerato",
        institucion: "Francisco José de Caldas",
        ubicacion: "Pandi, Cundinamarca"
    }
};

export default DataEducation;